let feeProducts = {
  running: false,
  checkout: false,

  init: function (checkout) {
    this.checkout = checkout;
    if (!this.running) {
      this.running = true;
      fetch('/cart?view=json').then(res => res.json()).then(response => {
        this.checkCartForFeeProduct(response);
      });
    }

  },

  checkCartForFeeProduct: function (data) {
    if (data.item_count < 1 || typeof data.items == "undefined") {
      this.running = false;
      return;
    }

    let items = data.items;
    let _this = this;

    // Helper function to get all items including bundle components
    function getAllItemsIncludingComponents(cartItems) {
      let allItems = [];

      cartItems.forEach(function(item) {
        // Check if this is a bundle parent
        if (item.properties && item.properties._bundle_string_1) {
          // For bundles, only process item_components
          if (item.item_components && item.item_components.length > 0) {
            item.item_components.forEach(function(component) {
              allItems.push({
                ...component,
                key: item.key + '_comp_' + component.variant_id, // Synthetic key for tracking
                parent_key: item.key, // Reference to parent bundle
                is_component: true
              });
            });
          }
        } else {
          // Regular items (not bundles) - add directly
          allItems.push(item);
        }
      });

      return allItems;
    }

    // Use the helper function
    let allItems = getAllItemsIncludingComponents(items);

    let personalizedItemsKeys = [];
    let feeProductsQuantities = {};

    // get required quantities for each fee product
    allItems.forEach(function (item) {
      for (let i = 1; i < 4; i++) {
        if (typeof item.properties['_personalized_' + i] != "undefined" && item.properties['_personalized_' + i] == 'true') {

          if (typeof item.properties['_fee_product_' + i] != "undefined") {
            let id = item.properties['_fee_product_' + i];
            if (feeProductsQuantities.hasOwnProperty(id)) {
              feeProductsQuantities[id] += item.quantity;
            } else {
              feeProductsQuantities[id] = item.quantity
            }
          }
        }
      }
    });

    let itemsToAdd = [];

    allItems.forEach(function (item) {
      let feeRequired = false;
      let feeInCart = false;
      let feeProductId = null;
      let feeItemKey = null;
      let targetItemKey = null;

      for (let i = 1; i < 4; i++) {
        // check if fee product needs to be added to cart and add it, if it's not already there
        if (typeof item.properties['_personalized_' + i] != "undefined" && item.properties['_personalized_' + i] == 'true') {
          feeRequired = true;
          personalizedItemsKeys.push(item.key)

          if (typeof item.properties['_fee_product_' + i] != "undefined") {
            feeInCart = false;
            feeProductId = null;
            feeItemKey = null;
            targetItemKey = null;

            let id = item.properties['_fee_product_' + i];
            feeProductId = parseInt(id);
            targetItemKey = item.key;

            items.forEach(function (feeItem) {
              if (feeItem.variant_id == feeProductId) {
                feeInCart = true;
                feeItemKey = feeItem.key;

                // fix qty if not enough/too many products in cart
                if (feeItem.quantity != feeProductsQuantities[feeProductId]) {
                  _this.updateItemQty(feeItemKey, feeProductsQuantities[feeProductId]);
                }
              }
            });

            // add fee product if required
            if (!feeInCart && feeRequired && feeProductId) {
              let added = false;
              itemsToAdd.forEach(function (itemToAdd) {
                if (itemToAdd.id == feeProductId) {
                  added = true;
                }
              });
              if (!added) {
                itemsToAdd.push({
                  'id': feeProductId,
                  'quantity': feeProductsQuantities[feeProductId],
                  'properties': {
                    '_is_fee_product': true,
                    '_target_item_key': targetItemKey
                  }
                });
              }
            }

            // remove fee product if not required
            else if (feeInCart && !feeRequired && feeProductId) {
              _this.updateItemQty(feeItemKey, 0);
            }
          }
        }
      }
    });

    setTimeout(function () {
      if (itemsToAdd.length > 0) _this.addFeeProductsToCart(itemsToAdd);
      _this.removeWrongFeeProducts(items, allItems, personalizedItemsKeys, feeProductsQuantities);
    }, 1);
  },

  addFeeProductsToCart: function (itemsToAdd) {
    let data = {
      items: itemsToAdd
    }

    let _this = this;
    fetch('/cart/add.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(response => {
      _this.updateCartDrawer();

      if (_this.checkout) window.location.href = '/checkout';
      if (response.status == 200) {
        if (document.querySelector('body').classList.contains('template-cart') || document.querySelector('body').classList.contains('shopify-checkout')) location.reload();
        _this.running = false;
      }
    });
  },

  updateItemQty: function (id, qty = 1) {
    let _this = this;
    fetch('/cart/change.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({id: id, quantity: qty})
    }).then(response => {

      _this.updateCartDrawer();

      if (_this.checkout) window.location.href = '/checkout';
      if (document.querySelector('body').classList.contains('template-cart') || document.querySelector('body').classList.contains('shopify-checkout')) {
        location.reload();
      }
      _this.running = false;
    });
  },

  updateItemQtys: function (data) {
    let _this = this;

    fetch('/cart/update.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({updates: data})
    }).then(response => {
      _this.updateCartDrawer();

      if (_this.checkout) window.location.href = '/checkout';
      if (document.querySelector('body').classList.contains('template-cart') || document.querySelector('body').classList.contains('shopify-checkout')) {
        location.reload();
      }
      _this.running = false;
    });

  },

  removeWrongFeeProducts: function (items, allItems, keys, feeProductsQuantities) {
    let updatedItems = 0;

    let itemsToUpdate = {};

    // Build a set of all valid keys (both regular and synthetic)
    let allValidKeys = new Set(keys);

    items.forEach(function (item) {
      if (typeof item.properties['_is_fee_product'] != "undefined") {
        let targetKey = item.properties['_target_item_key'];

        // Check if target key exists in our valid keys
        // OR if it matches a parent_key (for bundle components)
        let isValid = allValidKeys.has(targetKey);

        // Also check if this fee product's target is a component's parent
        if (!isValid) {
          allItems.forEach(function(checkItem) {
            if (checkItem.is_component && checkItem.parent_key === targetKey) {
              isValid = true;
            }
          });
        }

        if (!isValid) {
          // Fee product is orphaned - remove it
          for (let i = 1; i < 4; i++) {
            let id = parseInt(item.properties['_fee_product_' + i]);
            let qty = feeProductsQuantities[id];
            if (typeof qty == "undefined" || keys.length < 1) qty = 0;
            if (!itemsToUpdate.hasOwnProperty(item.key)) {
              itemsToUpdate[item.key] = qty;
            }
            updatedItems++;
          }
        }
      }
    });

    if (Object.keys(itemsToUpdate).length > 0) {
      this.updateItemQtys(itemsToUpdate);
    }

  },

  updateCartDrawer() {
    fetch('/cart?view=json').then(res => res.json()).then(response => {
      const cartContent = response;

      cartContent["sections"] = response["sections"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart: true
        }
      }));
    });
  }

}

feeProducts.init();

document.addEventListener("cart:updated", (e) => {
  feeProducts.init();
});

$(document).on('click', '.product-form .shopify-payment-button__button', function (e) {
  e.preventDefault();
  e.stopPropagation();
  let valid = validateProductForm(e.target);
  if (valid) {
    let addToCartForm = document.querySelector('.product-form form[action$="/cart/add"]');
    let formData = new FormData(addToCartForm);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(response => {

        const cartContent = response.json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));

        feeProducts.init(true);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
})